export function Card({ className = '', children, as: Tag = 'div', hover = false, ...props }) {
  return (
    <Tag className={`panel ${hover ? 'lift' : ''} ${className}`} {...props}>
      {children}
    </Tag>
  );
}

export function CardHeader({ title, description, blurb, actions, icon: Icon, className = '' }) {
  description = description ?? blurb;
  return (
    <div
      className={`flex flex-wrap items-start justify-between gap-3 border-b px-5 py-4 ${className}`}
      style={{ borderColor: 'rgb(var(--line-soft))' }}
    >
      <div className="flex min-w-0 items-start gap-2.5">
        {Icon && (
          <span className="grid h-7 w-7 shrink-0 place-items-center rounded-lg border border-line bg-surface-2 text-ink-soft">
            <Icon className="h-3.5 w-3.5" />
          </span>
        )}
        <div className="min-w-0">
          <h2 className="text-[0.95rem] font-semibold leading-tight tracking-[-0.005em] text-ink">{title}</h2>
          {description && <p className="mt-0.5 text-xs text-muted">{description}</p>}
        </div>
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}

export const CardBody = ({ className = '', children }) => (
  <div className={`p-5 ${className}`}>{children}</div>
);

/** The per-page hero: framed tile, optional eyebrow, title, subtitle, actions. */
export function PageHeader({ title, description, blurb, actions, icon: Icon, eyebrow, breadcrumb, dense = false }) {
  description = description ?? blurb;
  return (
    <header className={dense ? 'mb-4' : 'mb-6'}>
      {breadcrumb && <div className="mb-3 text-sm text-muted">{breadcrumb}</div>}

      <div className="flex flex-wrap items-start justify-between gap-5">
        <div className="flex min-w-0 items-start gap-3.5">
          {Icon && (
            <div
              className="grid h-10 w-10 shrink-0 place-items-center rounded-xl border"
              style={{
                background: 'rgb(var(--surface))',
                color: 'rgb(var(--ink))',
                borderColor: 'rgb(var(--line))',
                boxShadow: 'var(--shadow-xs)',
              }}
              aria-hidden="true"
            >
              <Icon className="h-[18px] w-[18px]" />
            </div>
          )}
          <div className="min-w-0">
            {eyebrow && <div className="eyebrow mb-1">{eyebrow}</div>}
            <h1 className="text-xl font-semibold tracking-tight text-ink lg:text-2xl">{title}</h1>
            {description && (
              <p className="mt-1 max-w-xl text-sm leading-relaxed text-muted">{description}</p>
            )}
          </div>
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </header>
  );
}

export default Card;
